// @flow
import TeamDetail from 'components/team/TeamDetail';
import { connect } from 'react-redux';
import { fetchPageList } from 'actions/pageActions';
import { fetchMatchsFutureTeam, fetchMatchsPastTeam } from 'actions/matchActions';
import { fetchTeamList } from 'actions/teamlistActions';
import { fetchArticlesCategory } from 'actions/newsletterCategoryActions';
import type { DispatchProps } from 'components/team/TeamDetail';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps } from 'components/team/TeamDetail';
import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      title: state.pageListState.title,
      description: state.pageListState.description,
      excerpt: state.pageListState.excerpt,
      label: state.pageListState.label,
      featured_media: state.pageListState.featured_media,
      liste_cards: state.cardState.liste_cards,
      articles: state.newsletterCategoryState.articles,
      status: state.pageListState.status,
      results_future: state.matchFutureTeamState.results_future,
      results_past: state.matchPastTeamState.results_past,
      meta_title: state.pageListState.meta_title,
      meta_description: state.pageListState.meta_description,
      youtube_playlist: state.pageListState.youtube_playlist,
      titre_youtube: state.pageListState.titre_youtube,
      teamlist: state.teamlistState.teamlist,
      redirection: state.pageListState.redirection,
      redirect_competitions: state.pageListState.redirect_competitions,
      redirect_resultats: state.pageListState.redirect_resultats,
      userPref: state.userState.userPref
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
      fetchMatchsFutureTeam: (start_date: string, team: string, per_page: number) =>
        dispatch(fetchMatchsFutureTeam(start_date, team, per_page)),
      fetchMatchsPastTeam: (end_date: string, team: string, per_page: number) =>
        dispatch(fetchMatchsPastTeam(end_date, team, per_page)),
      fetchTeamList: () => dispatch(fetchTeamList()),
      fetchArticlesCategory: (page: number, per_page: number, category: string) =>
        dispatch(fetchArticlesCategory(page, per_page, category))
    })
  )(TeamDetail)
);
